import development from './development.environment';
import qa from './qa.environment';
import production from './production.environment';

let environment = production;

if (process.env.REACT_APP_ENV === "development") environment = development;
if (process.env.REACT_APP_ENV === "test") environment = qa;

export default environment;